import React from "react";

export const PlayIcon = () => (
    <i className="icon ion-play volume"/>
);
